import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-card-content',
  standalone: true,
  imports: [],
  template: `
    <div class="white_card card_height_100">
      <div class="white_card_header">
        <ng-content select="[card-title]"></ng-content>
      </div>
      <div class="white_card_content">
        <ng-content select="[card-content]"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./card-content.component.css'],
})
export class CardContentComponent {}
